module.exports = __webpack_public_path__ + "828f2ea81ebb2dcaaef460e369d21e09.mp4";


//////////////////
// WEBPACK FOOTER
// ./app/assets/video/barn_nl.mp4
// module id = 939
// module chunks = 4